module.exports = __webpack_public_path__ + "static/media/group_guide_img_3_m.8bf2c53c.png";